import store from '@/store';
import { decisionRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';

import {
  SET_TRANSACTION_DECISION,
  SET_MAX_LOAN,
} from '@/lib/constants/mutations';

import PERFIOS_TRANSACTION from '@/lib/constants/store';

const getPayload = () => {
  const { appId } = store.state;
  const {
    duniaIncomeVerificationId,
    vendorIncomeVerificationId,
  } = store.state.formData[PERFIOS_TRANSACTION];

  return {
    'app-id': appId,
    'dunia-income-verification-id': duniaIncomeVerificationId,
    'vendor-income-verification-id': vendorIncomeVerificationId,
  };
};

export default {
  async isUserAllowed(currentStep, callbacks) {
    const currentStatus = store.state.formData[PERFIOS_TRANSACTION].status;

    if (currentStatus) {
      return currentStatus.toUpperCase();
    }

    const { form } = currentStep;
    var response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: decisionRepository.isUserAllowed,
      payload: getPayload(),
    });

  },
};
